import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ImgListComponent } from './ImgListComponent';
import { TitleSummary } from '../../style';
import MobileFormContext from '../../../../components/mobileForm/context/mobileFormContext';

export const ImageComponent = ({ field, parents, disableEdit, onFinishEdit }) => {
  const { updateMobileFormField, idService, uploadEvidences } = useContext(MobileFormContext);

  const onChange = async (imgList) => {
    const value = await uploadEvidences({
      value: imgList,
      newItemId: idService,
      idInput: field.idInput,
      onErrorUploading: () => {},
    });

    await updateMobileFormField({
      field: { ...field, value },
      parents,
    });
    if (onFinishEdit) {
      onFinishEdit({ saved: true });
    }
  };

  return (
    <React.Fragment key={field.idInput}>
      <TitleSummary>{field.label}</TitleSummary>
      <ImgListComponent
        field={field}
        value={field.value}
        onChange={onChange}
        parents={parents}
        disabledField={disableEdit}
      />
    </React.Fragment>
  );
};

ImageComponent.propTypes = {
  field: PropTypes.object.isRequired,
  parents: PropTypes.object,
  disableEdit: PropTypes.bool,
  onFinishEdit: PropTypes.func,
};
